export const extractSiteSection = (pathname: string): string | null => {
  const pathnameSegments = pathname.split('/');

  // {}/{ess}/{manage-requests}/{salary-certificate} - extract ess
  const siteSection = pathnameSegments[1];

  return siteSection || null;
};
